import url from './url';

const DEFAULT_IDENTITY = '00000000-0000-0000-0000-000000000000';
const exportObj = {};

function createUUID(mockedWindow) {
    mockedWindow = mockedWindow || window; // Since ie11 has no default parameters
    const hex = [];

    for (let i = 0; i < 256; i++) {
        hex[i] = (i < 16 ? '0' : '') + i.toString(16);
    }

    const fallbackAbleCrypto = mockedWindow.crypto || mockedWindow.msCrypto;
    if (!fallbackAbleCrypto) {
        return DEFAULT_IDENTITY;
    }

    const r = fallbackAbleCrypto.getRandomValues(new Uint8Array(16));

    r[6] = (r[6] & 0x0f) | 0x40;
    r[8] = (r[8] & 0x3f) | 0x80;

    return (
        hex[r[0]] +
        hex[r[1]] +
        hex[r[2]] +
        hex[r[3]] +
        '-' +
        hex[r[4]] +
        hex[r[5]] +
        '-' +
        hex[r[6]] +
        hex[r[7]] +
        '-' +
        hex[r[8]] +
        hex[r[9]] +
        '-' +
        hex[r[10]] +
        hex[r[11]] +
        hex[r[12]] +
        hex[r[13]] +
        hex[r[14]] +
        hex[r[15]]
    );
}

function getUsergrouphash() {
    let usergrouphash = undefined;

    const scriptTags = document.querySelectorAll('script[src*="autocomplete.js"],script[src*="main.js"]');
    if (scriptTags.length < 1) {
        console.warn('autocomplete.js or main.js script tag not found, cannot figure out usergrouphash');
    } else {
        const scriptTagsWithUsergroupHash = document.querySelectorAll(
            'script[src*="autocomplete.js?usergrouphash="],script[src*="main.js?usergrouphash="]'
        );

        if (scriptTagsWithUsergroupHash.length === 1) {
            const jsConfigScript = scriptTagsWithUsergroupHash[0];
            const src = jsConfigScript.src;
            const queryString = url.getQueryString(src);
            // Extract the value using a regular expression instead of something like FlUtil.parseQueryString(),
            // because the latter can't deal with trailing equality signs. E.g., for 'asd=', only 'asd' is
            // returned.
            const matches = queryString.match(/usergrouphash=([a-zA-Z0-9+/=]*)/);
            if (matches === null || matches.length < 2) {
                console.error('The provided usergrouphash contains illegal characters.');
            } else {
                usergrouphash = matches[1];
            }
        } else if (scriptTagsWithUsergroupHash.length > 1) {
            console.error('More than one autocomplete.js or main.js with usergrouphash hash found');
        } else {
            // No usergrouphash was given for the autocomplete.js or main.js, that's OK.
        }
    }

    return usergrouphash;
}

exportObj.createUUID = createUUID;
exportObj.getUsergrouphash = getUsergrouphash;

export default exportObj;
